// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimRejectedAggregatorDto
 */
export interface IClaimRejectedAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimRejectedAggregatorDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRejectedAggregatorDto
     */
    rejected_amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimRejectedAggregatorDto
     */
    plan_names?: Array<string>;
}

/**
 * Check if a given object implements the IClaimRejectedAggregatorDto interface.
 */
export function instanceOfIClaimRejectedAggregatorDto(value: object): value is IClaimRejectedAggregatorDto {
    return true;
}

export function IClaimRejectedAggregatorDtoFromJSON(json: any): IClaimRejectedAggregatorDto {
    return IClaimRejectedAggregatorDtoFromJSONTyped(json, false);
}

export function IClaimRejectedAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimRejectedAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'rejected_amount': json['rejected_amount'] == null ? undefined : json['rejected_amount'],
        'plan_names': json['plan_names'] == null ? undefined : json['plan_names'],
    };
}

export function IClaimRejectedAggregatorDtoToJSON(json: any): IClaimRejectedAggregatorDto {
    return IClaimRejectedAggregatorDtoToJSONTyped(json, false);
}

export function IClaimRejectedAggregatorDtoToJSONTyped(value?: IClaimRejectedAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'rejected_amount': value['rejected_amount'],
        'plan_names': value['plan_names'],
    };
}

